import { render, staticRenderFns } from "./sidebar-room.vue?vue&type=template&id=d3dfc314&"
import script from "./sidebar-room.vue?vue&type=script&lang=js&"
export * from "./sidebar-room.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-room.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports